import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, input, Signal } from "@angular/core";
import { RouterModule } from "@angular/router";
import { escapeHtmlUtil } from "src/app/common/templateUtils";
import { ToNumberedListPipe } from "src/app/pipes/toNumberedList/to-numbered-list.pipe";
import { NewLineCharToHtmlLineBreak } from "src/app/pipes/newLineCharToHtmlLineBreak/new-line-char-to-html-line-break.pipe";
import { CardFieldKey, ICardField } from "src/app/models/viewModels/cardModel";

@Component({
    selector: "app-toggle-content",
    templateUrl: "./toggle-content.component.html",
    styleUrls: ["./toggle-content.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RouterModule, ToNumberedListPipe, NewLineCharToHtmlLineBreak],
    standalone: true,
    host: {
        "[style.--expanded-max-height]": 'expandedMaxHeight + "px"',
        "[style.--truncated-max-height-for-conversation-starters-block]": `truncatedMaxHeightForConversationStartersBlock() + "px"`,
    },
})
export class ToggleContentComponent {
    public cardField = input.required<ICardField>();
    public readonly expandedMaxHeight = 200;
    public truncatedMaxHeightForConversationStartersBlock = input<number>();

    public readonly textContent: Signal<string> = computed(() => this.cardField().value ?? "");
    public readonly formattedHtmlContent: Signal<string> = computed(() => escapeHtmlUtil(this.textContent()));

    public readonly conversationStartersFieldName = CardFieldKey.ConversationStarters;

    public isExpanded = false;

    toggle(): void {
        this.isExpanded = !this.isExpanded;
    }
}
